'use strict';

module.exports = function simpleCheckerFactory (checkerName, checkFn, failMessage, makeNew, required) {
  let checker = (obj, key, cname, location, fullName) => {
    let value = obj[key];
    if (required || (value !== null && value !== undefined) && !checkFn(value)) {
      return new TypeError(`Value at ${fullName} ${failMessage}`);
    }
  };
  checker.checkerName = checkerName;
  if (makeNew) {
    checker.makeNew = makeNew;
  }
  if (required) {
    // already the required version
    checker.isRequired = checker;
  } else {
    checker.isRequired = simpleCheckerFactory(checkerName, checkFn, failMessage, makeNew, true);
  }
  return checker;
};



// WEBPACK FOOTER //
// ./lib/rlink-shapes/simpleCheckerFactory.js